export default "__VITE_ASSET__S2yRv$PN__"